import React, { useState } from 'react';
import { useQuery } from 'react-apollo';
import { FaEdit } from 'react-icons/fa';
import Select from 'react-select';
import { Button, Col, Row, Table } from 'reactstrap';
import { BeatLoader } from 'react-spinners';
import {
  GET_ALL_HOSPITALS,
  GET_DEPARTMENTAL_NUMBERS,
  GET_LOGGED_IN_USER
} from '../queries';
import DepartmentalNumbersEditModal from './DepartmentalNumbersEditModal';
import DeleteDepartmentalNumbers from '../pages/DeleteDepartmentalNumbers';
import ReactPaginate from 'react-paginate';

const DepartmentalNumber = () => {
  const [currentEditUser, setUser] = useState();
  const [hospital, setHospital] = useState();
  const [currentPage, setCurrentPage] = useState(0);

  const { data: { hospitals = [] } = {}, loading: isLoading } = useQuery(
    GET_ALL_HOSPITALS,
    {
      variables: { showAll: true }
    }
  );

  const {
    data: { me }
  } = useQuery(GET_LOGGED_IN_USER);

  const { data, loading: isDepartmentalLoading } = useQuery(
    GET_DEPARTMENTAL_NUMBERS,
    {
      variables: { hospitalId: hospital && hospital.id },
      skip: !hospital || !hospital.id
    }
  );

  const departmentalNumbers =
    (data && data.getDepartmentalNumbersByHospitalId) || [];
  const pageSize = 12;
  const pageCount = Math.ceil(departmentalNumbers.length / pageSize);
  const paginatedData = departmentalNumbers.slice(
    currentPage * pageSize,
    (currentPage + 1) * pageSize
  );

  const hideModal = () => setUser(undefined);
  const editUser = user => setUser(user);

  const onHospitalChange = value => setHospital(value);
  let filteredHospital = hospitals;

  if (me.role !== 'customersupport' && me.hospitals.length > 0) {
    filteredHospital = hospitals.filter(h => me.hospitals.includes(h.id));
  }

  const setPage = ({ selected }) => setCurrentPage(selected);
  return (
    <>
      <h1 style={{ display: 'flex', alignItems: 'center' }}>
        Departmental Numbers
      </h1>

      <h3 className="d-flex mb-4">
        Contact information for different hospital departments
      </h3>

      <Row>
        <Col>
          <div className="d-flex justify-content-between">
            <div style={{ minWidth: '30rem' }}>
              <Select
                placeholder="Select Hospital..."
                value={hospital}
                options={filteredHospital}
                isLoading={isLoading}
                onChange={onHospitalChange}
                getOptionLabel={({ name }) => name}
                getOptionValue={({ id }) => id}
              />
            </div>
          </div>
        </Col>
        <Col>
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            {hospital && (
              <Button
                color="primary"
                size="sm"
                disabled={me.role === 'customersupport'}
                onClick={() =>
                  editUser({
                    department: '',
                    level1Contact: '',
                    level2Contact: '',
                    level3Contact: '',
                    hospitalId: hospital ? hospital.id : ''
                  })
                }
              >
                Add New
              </Button>
            )}
          </div>
        </Col>
      </Row>

      <div style={{ marginTop: '30px' }}>
        {hospital ? (
          isDepartmentalLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <BeatLoader />
            </div>
          ) : (
            <>
              <Table size="sm" striped responsive>
                <thead>
                  <tr>
                    <th>Department</th>
                    <th>Level 1 Contact</th>
                    <th>Level 2 Contact</th>
                    <th>Level 3 Contact</th>
                    <th>Edit Details</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map(d => (
                    <tr key={d.id + d.department}>
                      <td>{d.department}</td>
                      <td>{d.level1Contact}</td>
                      <td>{d.level2Contact}</td>
                      <td>{d.level3Contact}</td>
                      <td>
                        {d.updatedAt
                          ? `${d.lastUpdatedBy} on ${d.updatedAt}`
                          : `${d.lastUpdatedBy} on ${d.createdAt}`}
                      </td>
                      <td
                        style={{
                          display: 'flex',
                          justifyContent: 'start',
                          alignItems: 'center'
                        }}
                      >
                        <Button
                          color="link"
                          onClick={() => {
                            editUser({
                              department: d.department,
                              hospitalId: d.hospitalId,
                              id: d.id,
                              level1Contact: d.level1Contact,
                              level2Contact: d.level2Contact,
                              level3Contact: d.level3Contact
                            });
                          }}
                          disabled={me.role === 'customersupport'}
                        >
                          <FaEdit />
                        </Button>
                        <span>|</span>
                        <DeleteDepartmentalNumbers
                          departmentalNumbersId={d.id}
                          department={d.department}
                          isDisabled={me.role === 'customersupport'}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ReactPaginate
                  containerClassName="pagination"
                  pageCount={pageCount}
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={2}
                  initialPage={currentPage}
                  onPageChange={setPage}
                />
              </div>
            </>
          )
        ) : (
          <h3 className="d-flex mt-5">
            Please select a hospital to view departmental numbers
          </h3>
        )}
      </div>

      <DepartmentalNumbersEditModal
        isOpen={!!currentEditUser}
        hideModal={hideModal}
        departmentalNumber={currentEditUser}
        onSave={hideModal}
        role={me}
      />
    </>
  );
};

export default DepartmentalNumber;
